/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{
  "rawString": ".root_dd790ee3{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_dd790ee3{height:100%;fill:currentColor;vertical-align:top;forced-color-adjust:auto}"
}]);
export const root = "root_dd790ee3";
export const svg = "svg_dd790ee3";